import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResult } from '@enterprise/types';

import { Uri } from '#constants/uri';

/**
 * Removes a role directly assigned to a user.
 *
 * @param instance - Ky HTTP instance from the application store.
 * @param uid - Unique identifier of the user.
 * @param roleUid - Unique identifier of the role to remove.
 * @returns OperationResult (no payload).
 */
export const deleteUserRole = async (instance: KyInstance, uid: string, roleUid: string) => {
  try {
    return await instance.delete<OperationResult>(formatString(Uri.users.roleByUid, uid, roleUid)).json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
